import { render, staticRenderFns } from "./authorization.vue?vue&type=template&id=e5a7d7d6&scoped=true"
import script from "./authorization.vue?vue&type=script&lang=js"
export * from "./authorization.vue?vue&type=script&lang=js"
import style0 from "./authorization.vue?vue&type=style&index=0&id=e5a7d7d6&prod&lang=less&scoped=true"
import style1 from "./authorization.vue?vue&type=style&index=1&id=e5a7d7d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a7d7d6",
  null
  
)

export default component.exports